import _ from 'lodash';
import {ActionTypes} from '../actions';
import {Parameters} from '../../common/actionTypes';
import {pickingLabelsPrint} from '../../common/util/print';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loadingDealers': false,
  'dealersList': [],
  'loadingAgencies': false,
  'agenciesList': [],
  'loadingOrders': false,
  'ordersList': [],
  'ordersListByPage': [],
  'pageNumber': 0,
  'pageSize': 10,
  'loadingOrderDetail': false,
  'orderDetail': {},
  'orderDetailItems': [],
  'orderDetailItemsByPage': [],
  'printingPickingLabels': false,
  'quantityLabelsToCut': 10,
  'saving': false,
  'updatingOrders': false,
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

const markItem = (orderDetailItems, {position, enabled}) => {
  let updatedItems = [];

  if (position === 'ALL') {
    updatedItems = orderDetailItems.map((item) => {
      if (item.status === 'P') {
        return {...item, 'checked': enabled};
      }
      return item;
    });
    return updatedItems;
  }

  const newItems = [...orderDetailItems];
  const itemChanged = {...newItems[position]};
  itemChanged.checked = enabled;
  return [...orderDetailItems.slice(0, position), itemChanged, ...orderDetailItems.slice(position + 1)];
};

const changeStatus = (orderDetailItems, labels) => {
  pickingLabelsPrint(labels);
  const newItems = [...orderDetailItems];

  labels.forEach((element) => {
    const position = _.findIndex(orderDetailItems, {'orderSequence': element.orderSequence});
    const itemChanged = {...newItems[position]};
    itemChanged.status = 'E';
    itemChanged.printDate = element.date;

    newItems[position] = {...itemChanged};
  });
  return newItems;
};

export const manualsOrders = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_SPECIALS_ORDERS_DATA]: (state, action) => {
      const type = action.payload;
      if (type === 'ALL') {
        return ({
          ...state,
          'pageNumber': 0,
          'dealersList': [],
          'agenciesList': [],
          'ordersList': [],
          'ordersListByPage': [],
          'orderDetailItems': [],
          'orderDetailItemsByPage': [],
          'saving': false,
        });
      }
      return ({
        ...state,
        'pageNumber': 0,
        'ordersList': [],
        'ordersListByPage': [],
      });
    },
    [ActionTypes.FETCHING_PICKING_DEALERS]: (state, action) => ({
      ...state,
      'loadingDealers': true,
    }),
    [ActionTypes.FETCHED_PICKING_DEALERS]: (state, action) => ({
      ...state,
      'loadingDealers': false,
      'dealersList': action.response.data,
    }),
    [ActionTypes.FETCHED_PICKING_DEALERS_FAILED]: (state, action) => ({
      ...state,
      'loadingDealers': false,
      'dealersList': [],
    }),
    [ActionTypes.FETCHING_PICKING_AGENCIES]: (state, action) => ({
      ...state,
      'loadingAgencies': true,
    }),
    [ActionTypes.FETCHED_PICKING_AGENCIES]: (state, action) => ({
      ...state,
      'loadingAgencies': false,
      'agenciesList': action.response.data,
    }),
    [ActionTypes.FETCHED_PICKING_AGENCIES_FAILED]: (state, action) => ({
      ...state,
      'loadingAgencies': false,
      'agenciesList': [],
    }),
    [ActionTypes.UPDATING_ORDERS]: (state, action) => ({
      ...state,
      'updatingOrders': true,
    }),
    [ActionTypes.UPDATED_ORDERS]: () => ({
      ...state,
      'updatingOrders': false,
    }),
    [ActionTypes.UPDATED_ORDERS_FAILED]: () => ({
      ...state,
      'updatingOrders': false,
    }),
    [ActionTypes.FETCHING_ORDERS]: (state, action) => ({
      ...state,
      'loadingOrders': true,
    }),
    [ActionTypes.FETCHED_ORDERS]: (state, action) => ({
      ...state,
      'loadingOrders': false,
      'ordersList': action.response.data,
      'ordersListByPage': [...getPage(action.response.data, 0, state.pageSize)],
    }),
    [ActionTypes.FETCHED_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'loadingOrders': false,
      'ordersList': [],
      'ordersListByPage': [],
    }),
    [ActionTypes.CHANGE_ORDERS_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'ordersListByPage': [...getPage(state.ordersList, action.payload, state.pageSize)],
      'orderDetailItemsByPage': [...getPage(state.orderDetailItems, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_ORDERS_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'ordersListByPage': [...getPage(state.ordersList, 0, action.payload)],
      'orderDetailItemsByPage': [...getPage(state.orderDetailItems, 0, action.payload)],
    }),
    [Parameters.FETCHED_SYSTEM_PARAMETER]: (state, action) => ({
      ...state,
      'quantityLabelsToCut': action.response.data.value,
    }),
    [ActionTypes.FETCHING_ORDER_DETAIL]: (state, action) => ({
      ...state,
      'loadingOrderDetail': true,
    }),
    [ActionTypes.FETCHED_ORDER_DETAIL]: (state, action) => {
      const orderInfo = action.response.data;

      const orderInfoWithoutDetail = {...orderInfo};
      delete orderInfoWithoutDetail.detail;
      return ({
        ...state,
        'loadingOrderDetail': false,
        'orderDetail': orderInfoWithoutDetail,
        'orderDetailItems': orderInfo.detail,
        'orderDetailItemsByPage': [...getPage(orderInfo.detail, 0, state.pageSize)],
      });
    },
    [ActionTypes.FETCHED_ORDER_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingOrderDetail': false,
      'orderDetail': {},
      'orderDetailItems': [],
      'orderDetailItemsByPage': [],
    }),
    [ActionTypes.CHANGE_STATUS_FOR_SELECTED_ITEM]: (state, action) => {
      const newItems = markItem(state.orderDetailItems, action.payload);
      return ({
        ...state,
        'orderDetailItems': [...newItems],
        'orderDetailItemsByPage': [...getPage(newItems, state.pageNumber, state.pageSize)],
      });
    },
    [ActionTypes.PRINTED_LABELS_BY_ORDER_NUMBER_AND_SEQUENTIAL]: (state, action) => {
      pickingLabelsPrint(action.response.data, state.quantityLabelsToCut);
      return ({
        ...state,
        'printingPickingLabels': false,
      });
    },
    [ActionTypes.SAVING_ITEMS_SELECTED]: (state, action) => ({
      ...state,
      'saving': true,
    }),
    [ActionTypes.SAVED_ITEMS_SELECTED]: (state, action) => {
      const newItems = changeStatus(state.orderDetailItems, action.response.data);
      return ({
        ...state,
        'saving': false,
        'orderDetailItems': [...newItems],
        'orderDetailItemsByPage': [...getPage(newItems, state.pageNumber, state.pageSize)],
      });
    },
    [ActionTypes.SAVED_ITEMS_SELECTED_FAILED]: (state, action) => ({
      ...state,
      'saving': false,
    }),
  })(state, action);
};
